module.exports = __webpack_public_path__ + "static/media/firebase.1c16b537.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/firebase.png
// module id = 96
// module chunks = 0